export interface IDealerSetting {
  key: DealerSettingName;
  value: string;
  displayName: DealerSettingName;
  type: string;
  children?: IDealerSetting[];
}

export enum DealerSettingName {
  truConnectEnabled = 'truConnectEnabled',
  smartRepliesEnabled = 'smartRepliesEnabled',
  messageProfessionalizationEnabled = 'messageProfessionalizationEnabled',
  messageTranslationEnabled = 'translationServiceEnabled',
  messagingI18N = 'messagingI18N',
  truConnectGroupName = 'truConnectGroupName',
  language = 'language',
  theme = 'theme',
  dealerTheme = 'brand-customization',
  logo = 'logo',
  typography = 'typography',
  enableTextConversation = 'enableTextConversation',
  serviceExplicitOptInEnabled = 'serviceExplicitOptInEnabled',
  WhatsAppSalesModule = 'WhatsAppSalesModule',
  enabledWelcomeMessage = 'enabledWelcomeMessage',
  WhatsAppServiceModule = 'WhatsAppServiceModule',
  dealerTimezone = 'dealerTimezone',
  useBotMode = 'useBotMode',
  channelOwnerAutoReassignEnabled = 'channelOwnerAutoReassignEnabled',
  dealerName = 'dealerName',
}
